module.exports = __webpack_public_path__ + "static/media/office_8@2x.92dda047.jpg";